import { Field, useFormikContext } from 'formik'
import TagsBox from 'components/TagsBox'

const FilterData = ({ id }) => {
  const { values, setFieldValue } = useFormikContext()

  const setFilterData = (name, data) => {
    setFieldValue(name, data)
  }

  return (
    <section id={id}>
      <h3 id={id} className="header-title">
        Filter Data
      </h3>
      <div className="content-wrapper">
        <Field
          component={TagsBox}
          handleValueChange={(tagsValues) => {
            setFilterData('filterData', {
              ...values?.filterData,
              location: tagsValues,
            })
          }}
          placeholder="Location Tags"
          data={values.filterData?.location}
          dataCy="location-tags"
        />
      </div>
      <div className="content-wrapper -flags-wrapper -padding-top-none">
        <Field
          component={TagsBox}
          handleValueChange={(tagsValues) => {
            setFilterData('filterData', {
              ...values?.filterData,
              cuisine: tagsValues,
            })
          }}
          data={values.filterData?.cuisine}
          placeholder="Cuisine Tags"
          dataCy="cuisine-tags"
        />
      </div>
    </section>
  )
}

export default FilterData
